import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface DraftState {
  /** key: 'home' 或 `reply:<postId>` / `quote:<postId>` */
  drafts: Record<string, string>
  setDraft: (key: string, text: string) => void
  clearDraft: (key: string) => void
}

export const useDraftStore = create<DraftState>()(
  persist(
    (set) => ({
      drafts: {},
      setDraft: (key, text) => set((state) => ({ drafts: { ...state.drafts, [key]: text } })),
      clearDraft: (key) =>
        set((state) => {
          const { [key]: _removed, ...rest } = state.drafts
          return { drafts: rest }
        }),
    }),
    { name: 'rex-drafts' },
  ),
)
